import React from "react";
import {SearchOutlined} from "@ant-design/icons";
import {SearchInput, EnterButton} from "./FilterComponentStyles";
import {SearchTextPropTypes} from "./FilterComponentPropTypes";
import {useTranslation} from "react-i18next";

const SearchText = ({
    value,
    onChange,
    label,
    showLabel = true,
    placeholder,
    showPlaceholder = false,
    loading
}: SearchTextPropTypes) => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            {showLabel && <h5>{label || t("filters.search", {ns: "common"})}</h5>}
            <SearchInput
                defaultValue={value}
                data-testid="searchInput"
                onSearch={onChange}
                placeholder={
                    showPlaceholder ? placeholder || t("filters.search", {ns: "common"}) : ""
                }
                allowClear
                enterButton={
                    <EnterButton data-testid="searchInput_searchButton" icon={<SearchOutlined />} />
                }
                disabled={loading}
            />
        </React.Fragment>
    );
};

export default SearchText;
